import React from "react";
import Modal from "react-bootstrap/Modal";

interface Props {
  onHide: () => void;
  show: boolean;
  header: string;
  bodyHeadline: string;
  bodyContent: string;
  submitButton: boolean;
  cancelButton: boolean;
  submitButtonContent: string;
  cancelButtonContent: string;
}

const BaseModal = (props: Props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="base-modal"
    >
      <Modal.Header closeButton className="header">
        <Modal.Title id="contained-modal-title-vcenter" className="title">
          {props.header}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="body">
        <h4>{props.bodyHeadline}</h4>
        <p>{props.bodyContent}</p>
      </Modal.Body>
      <Modal.Footer className="footer">
        {props.cancelButton ? (
          <button className="cancel-button" onClick={props.onHide}>
            {props.cancelButtonContent}
          </button>
        ) : null}
        {props.submitButton ? (
          <button className="submit-button" onClick={props.onHide}>
            {props.submitButtonContent}
          </button>
        ) : null}
      </Modal.Footer>
    </Modal>
  );
};

export default BaseModal;
